// extracted by mini-css-extract-plugin
module.exports = {"border":"border__bJo4K"};